import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmergencyHome = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.99974 14.6833C7.82196 14.6833 7.65252 14.65 7.49141 14.5833C7.3303 14.5167 7.18307 14.4222 7.04974 14.3L1.69974 8.94998C1.57752 8.81665 1.48307 8.66943 1.41641 8.50832C1.34974 8.34721 1.31641 8.17776 1.31641 7.99998C1.31641 7.82221 1.34974 7.64998 1.41641 7.48332C1.48307 7.31665 1.57752 7.17221 1.69974 7.04998L7.04974 1.69998C7.18307 1.56665 7.3303 1.46943 7.49141 1.40832C7.65252 1.34721 7.82196 1.31665 7.99974 1.31665C8.17752 1.31665 8.34974 1.34721 8.51641 1.40832C8.68307 1.46943 8.82752 1.56665 8.94974 1.69998L14.2997 7.04998C14.4331 7.17221 14.5303 7.31665 14.5914 7.48332C14.6525 7.64998 14.6831 7.82221 14.6831 7.99998C14.6831 8.17776 14.6525 8.34721 14.5914 8.50832C14.5303 8.66943 14.4331 8.81665 14.2997 8.94998L8.94974 14.3C8.82752 14.4222 8.68307 14.5167 8.51641 14.5833C8.34974 14.65 8.17752 14.6833 7.99974 14.6833ZM7.33307 8.66665H8.66641V4.66665H7.33307V8.66665ZM7.99974 10.6667C8.18863 10.6667 8.34696 10.6028 8.47474 10.475C8.60252 10.3472 8.66641 10.1889 8.66641 9.99998C8.66641 9.8111 8.60252 9.65276 8.47474 9.52498C8.34696 9.39721 8.18863 9.33332 7.99974 9.33332C7.81085 9.33332 7.65252 9.39721 7.52474 9.52498C7.39696 9.65276 7.33307 9.8111 7.33307 9.99998C7.33307 10.1889 7.39696 10.3472 7.52474 10.475C7.65252 10.6028 7.81085 10.6667 7.99974 10.6667Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgEmergencyHome);
export default ForwardRef;
